module.exports = __webpack_public_path__ + "static/media/feedbackActive.127198d6.svg";